export const selectedCloudConfigKey = 'selectedCloudConfiguration';

export const recentProjectIdsKey = 'recentProjectsIds';
export const recentProjectIdsLimit = 3;

export const needReviewEnvironmentProjectIdsFilterKey = 'needReviewEnvironmentProjectIdsFilter';
export const needReviewEnvironmentTemplateIdsFilterKey = 'needReviewEnvironmentTemplateIdsFilter';
